import React from "react";
import ListPage from "../../base/ListPage.js";
import APILXD from "../../../http/APILXD.js";
import { Modal, message, Button, Space, Input, Typography } from "antd";
import TimeHelp from "../../../tool/TimeHelp";
import HttpTool from "../../../tool/HttpTool";
import dayjs from "dayjs";

const ReportConfigs = {
  1: "技能",
  2: "职业",
  3: "文档",
  4: "课程",
  5: "评论",
  6: "社区问答",
  7: "社区文章",
};

const CommentTypeConfigs = {
  1: "文档评论",
  2: "课程评论",
  3: "社区评论",
};

export default class ReportListPage extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.getReportList,
        otherParam: null,
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          hideSeniorBtn: true,
          hideInput: true,
          placeholder: "",
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.createTime) {
              value.startTime = dayjs(value.createTime[0]).valueOf();
              value.endTime = dayjs(value.createTime[1]).valueOf();
            }
            return true;
          },
        },
      },
    };
  }

  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18, offset: 0 },
      },
      parameterArr: [
        {
          field: "reviewType",
          name: "举报对象",
          type: "select",
          selectType: "value",
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: "技能",
              value: 1,
            },
            {
              title: "职业",
              value: 2,
            },
            {
              title: "文档",
              value: 3,
            },
            {
              title: "课程",
              value: 4,
            },
            {
              title: "评论",
              value: 5,
            },
            {
              title: "社区问答",
              value: 6,
            },
            {
              title: "社区文章",
              value: 7,
            },
          ],
        },
        {
          field: "reviewContent",
          name: "举报内容",
          type: "Input",
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
        },
        {
          field: "createTime",
          name: "举报时间",
          reg: (txt) => {
            return !!txt;
          },
          type: "rangePicker",
          verMessage: "请选择",
          option: {
            showTime: true,
            style: { width: "100%" },
            format: "YYYY-MM-DD HH:mm:ss",
            placeholder: ["起始时间", "结束时间"],
          },
        },
        {
          field: "createUser",
          name: "举报人",
          type: "Input",
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
        },
      ],
    };
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: "举报对象",
        dataIndex: "reviewType",
        key: "reviewType",
        width: 120,
        render: (text, record) => {
          return <div>{record.reviewType === 5 ? CommentTypeConfigs[record?.commentType] : (ReportConfigs[text] || "未知")}</div>;
        },
      },
      {
        title: "举报内容",
        dataIndex: "reviewContent",
        key: "reviewContent",
        width: 300,
      },
      {
        title: "举报原因",
        dataIndex: "reviewReason",
        key: "reviewReason",
        width: 360,
        render: (text) => {
          return (
            <div style={{ minWidth: 360 }}>
              <Typography.Paragraph
                ellipsis={{ rows: 3, expandable: true, symbol: "more" }}
                style={{
                  wordWrap: "break-word",
                }}
              >
                {text}
              </Typography.Paragraph>
            </div>
          );
        },
      },
      {
        title: "举报时间",
        dataIndex: "createTime",
        key: "createTime",
        width: 120,
        render: (text) => {
          let time = TimeHelp.getYMDHM(text);
          return <div>{time}</div>;
        },
      },
      {
        title: "举报人",
        dataIndex: "createUser",
        key: "createUser",
        width: 100,
      },
      {
        title: "状态",
        dataIndex: "reviewStatus",
        key: "reviewStatus",
        width: 80,
        render: (text, record) => {
          return (
            <div>
              <div>
                {
                  {
                    0: <span style={{ color: "darkorange" }}>待处理</span>,
                    1: <span style={{ color: "blue" }}>已忽略</span>,
                    2: <span style={{ color: "limegreen" }}>已下架</span>,
                    3: <span style={{ color: "red" }}>已删除</span>,
                  }[text]
                }
              </div>
            </div>
          );
        },
      },
      {
        title: "操作",
        width: 200,
        render: (text, record, index) => {
          return (
            <div>{this.getActionByStatusType(record.reviewStatus, record)}</div>
          );
        },
      },
    ];
  }

  getActionByStatusType(statusType, record) {
    switch (statusType) {
      case 0: // 未处理
        return (
          <Space>
            <Button
              size={"small"}
              type={"primary"}
              onClick={() => {
                this.ignoreState(record);
              }}
            >
              忽略
            </Button>

            <Button
              size={"small"}
              type={"primary"}
              danger={true}
              onClick={() => {
                this.delState(record, "success");
              }}
            >
              {[1, 2, 3, 4, 6, 7].includes(record.reviewType) ? "下架" : "删除"}
            </Button>
          </Space>
        );
      case 1: // 已忽略
        return (
          <Space>
            <Button
              size={"small"}
              type={"primary"}
              danger={true}
              onClick={() => {
                this.delState(record);
              }}
            >
              {[1, 2, 3, 4, 6, 7].includes(record.reviewType) ? "下架" : "删除"}
            </Button>
          </Space>
        );
      case 2: // 已下架
      case 3: // 已删除 （评论、文章）
        return null;
    }
    return null;
  }

  /**
   * 忽略
   */
  ignoreState(record) {
    Modal.confirm({
      title: "提示",
      content: (
        <div>
          确定要<span style={{ color: "red", fontSize: "20px" }}>忽略</span>
          该举报信息吗？
        </div>
      ),

      okText: "确定",
      cancelText: "取消",
      okType: "danger",
      onOk: () => {
        let param = {
          reviewId: record._id,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({ loading: false }, () => {
            message.success("操作成功");
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({ loading: false }, () => {
            message.error(msg);
          });
        };

        this.setState({ loading: true });

        HttpTool.post(APILXD.ignoreReport, successCB, failureCB, param);
      },
    });
  }

  // 下架或删除
  delState(record) {
    const isOffReview = record.reviewType === 5; // 评论是直接删除，其他的是下架
    let reason = null;
    // 技能和职业单独处理
    if ([1, 2].includes(record.reviewType)) {
      const delistModal = Modal.confirm({
        title: "提示",
        content: (
          <div>
            确定下架该{ReportConfigs[record.reviewType]}吗？
            <div style={{ marginTop: "20px" }}>
              <Input.TextArea
                placeholder={"请输入下架原因"}
                maxLength={100}
                onChange={(e) => {
                  reason = e.target.value;
                  delistModal.update({
                    okButtonProps: {
                      disabled: !reason || reason.trim() === "",
                    },
                  });
                }}
              />
            </div>
          </div>
        ),
        okText: "确定",
        cancelText: "取消",
        okType: "danger",
        okButtonProps: {
          disabled: !reason || reason.trim() === "",
        },
        onOk: () => {
          return new Promise((resolve, reject) => {
            let param = {
              reviewId: record._id,
              offRemark: reason,
              reviewType: record.reviewType,
            };
            let successCB = (code, msg, json, option) => {
              this.setState({ loading: false }, () => {
                message.success("操作成功");
                this._loadDataForNet();
              });
              resolve(true);
            };
            let failureCB = (code, msg) => {
              this.setState({ loading: false }, () => {
                message.error(msg);
                reject(false);
              });
            };

            this.setState({ loading: true });

            HttpTool.post(APILXD.offReport, successCB, failureCB, param);
          });
        },
      });
    } else {
      Modal.confirm({
        title: "提示",
        content: (
          <div>
            确定{[3, 4, 6, 7].includes(record.reviewType) ? "下架" : "删除"}该
            {ReportConfigs[record.reviewType]}吗？
          </div>
        ),
        okText: "确定",
        cancelText: "取消",
        okType: "danger",
        onOk: () => {
          return new Promise((resolve, reject) => {
            let param = isOffReview
              ? {
                  reviewId: record._id,
                }
              : {
                  reviewId: record._id,
                  reviewType: record.reviewType,
                };
            let successCB = (code, msg, json, option) => {
              this.setState({ loading: false }, () => {
                message.success("操作成功");
                this._loadDataForNet();
              });
              resolve(true);
            };
            let failureCB = (code, msg) => {
              this.setState({ loading: false }, () => {
                message.error(msg);
                reject(false);
              });
            };

            this.setState({ loading: true });

            HttpTool.post(
              isOffReview ? APILXD.delReportComment : APILXD.offReport,
              successCB,
              failureCB,
              param
            );
          });
        },
      });
    }
  }
}
